import React from "react";
import styles from "../../../../styles/mailCenter/templateCardSkeleton.module.scss";


const TemplateCardSkeleton: React.FC = () => (
  <div className={styles["skeleton-card"]}>

    {/* Header — title + badge */}
    <div className={styles["skeleton-card__header"]}>
      <div className={styles["skeleton-card__title"]} />
      <div className={styles["skeleton-card__badge"]} />
    </div>

    {/* Subject section */}
    <div className={styles["skeleton-card__section"]}>
      <div className={styles["skeleton-card__section-label"]} />
      <div className={styles["skeleton-card__subject-box"]} />
    </div>

    {/* Preview section */}
    <div className={styles["skeleton-card__section"]}>
      <div className={styles["skeleton-card__section-label"]} />
      <div className={styles["skeleton-card__preview-line"]} />
      <div className={styles["skeleton-card__preview-line"]} />
      <div className={styles["skeleton-card__preview-line"]} />
      <div className={styles["skeleton-card__preview-line"]} />
    </div>

    {/* Meta */}
    <div className={styles["skeleton-card__meta"]}>
      <div className={styles["skeleton-card__meta-item"]} />
      <div className={styles["skeleton-card__meta-item"]} />
    </div>

    {/* Actions */}
    <div className={styles["skeleton-card__actions"]}>
      <div className={styles["skeleton-card__preview-btn"]} />
      <div className={styles["skeleton-card__icon-btn"]} />
      <div className={styles["skeleton-card__icon-btn"]} />
      <div className={styles["skeleton-card__icon-btn"]} />
    </div>

  </div>
);

export default TemplateCardSkeleton;